module.exports = "../../static/img/partner.b2c8faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/partner.png
// module id = Phyp
// module chunks = 1